/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Button } from "./button";
import { ButtonGroup } from "./button-group";
export var BUTTON_GROUP_DIRECTIVES = [
    Button, ButtonGroup
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button-group/index.js
// module id = 142
// module chunks = 4